import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import ProfilImage from "./ProfileImage";
import { toast } from "react-toastify";

class Profil extends Component {
    state = {
        id: null, btn: false, passwordBtn: false, password: "", confirmed: "",
        first_name: "", last_name: "", family_name: "", email: "", tel: "", adress: "",
        profileError: "", passwordError: "", profileSaved: false,
    };

    componentDidMount() { this.loadUser(); }

    loadUser = () => {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        if (!user) return;
        this.setState({
            id: user.id, first_name: user.first_name || "", last_name: user.last_name || "",
            family_name: user.family_name || "", avatar: user.avatar || "", tel: user.tel || "",
            email: user.email || "", adress: user.adress || "",
        });
    };

    storeProfile = async () => {
        if (!this.state.id) {
            window.location.replace(process.env.REACT_APP_EVIVESOMA_COMPTA + "/login");
            return;
        }
        const data = {
            first_name: this.state.first_name, last_name: this.state.last_name,
            family_name: this.state.family_name, email: this.state.email || null,
            tel: this.state.tel || null, adress: this.state.adress,
        };
        this.setState({ btn: true, profileError: "", profileSaved: false });
        try {
            const response = await axios.put("users_/" + this.state.id, data);
            const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
            localStorage.setItem("user", JSON.stringify({ ...currentUser, ...data }));
            this.setState({ btn: false, profileSaved: true });
            toast(response?.data?.msg || "Profil mis à jour", { theme: "light", style: { backgroundColor: "#157347", color: "white" } });
        } catch (error) {
            const message = error.response?.data?.msg || "Impossible de modifier le profil.";
            this.setState({ btn: false, profileError: message });
            toast(message, { theme: "light", style: { backgroundColor: "#b42318", color: "white" } });
        }
    };

    storePassword = async () => {
        if (!this.state.password) {
            this.setState({ passwordError: "Saisissez un nouveau mot de passe." });
            toast("Saisissez un nouveau mot de passe.", { theme: "light", style: { backgroundColor: "#b42318", color: "white" } });
            return;
        }
        if (this.state.password !== this.state.confirmed) {
            this.setState({ passwordError: "Les mots de passe ne correspondent pas." });
            toast("Les mots de passe ne correspondent pas.", { theme: "light", style: { backgroundColor: "#b42318", color: "white" } });
            return;
        }
        this.setState({ passwordBtn: true, passwordError: "" });
        try {
            const response = await axios.put("users/" + this.state.id, { password: this.state.password });
            this.setState({ passwordBtn: false, password: "", confirmed: "" });
            toast(response?.data?.msg || "Mot de passe modifié", { theme: "light", style: { backgroundColor: "#157347", color: "white" } });
        } catch (error) {
            const message = error.response?.data?.msg || "Impossible de modifier le mot de passe.";
            this.setState({ passwordBtn: false, passwordError: message });
            toast(message, { theme: "light", style: { backgroundColor: "#b42318", color: "white" } });
        }
    };

    handleInput = (event) => {
        const passwordField = event.target.name === "password" || event.target.name === "confirmed";
        this.setState({
            [event.target.name]: event.target.value, profileSaved: false,
            profileError: passwordField ? this.state.profileError : "",
            passwordError: passwordField ? "" : this.state.passwordError,
        });
    };

    getInitials = () => {
        const names = [this.state.last_name || this.state.family_name, this.state.first_name].filter(Boolean);
        return names.map((name) => String(name).charAt(0)).join("").slice(0, 2).toUpperCase() || "UT";
    };

    renderField = (name, label, icon, type = "text", placeholder = "") => (
        <div className="account-profile-field">
            <label htmlFor={`profile-${name}`}>{label}</label>
            <div className="account-profile-input">
                <FeatherIcon icon={icon} size={16} aria-hidden="true" />
                <input id={`profile-${name}`} type={type} name={name} value={this.state[name]}
                    onChange={this.handleInput} placeholder={placeholder}
                    autoComplete={type === "password" ? "new-password" : undefined} />
            </div>
        </div>
    );

    render() {
        const storedProfile = JSON.parse(localStorage.getItem("profile") || "{}");
        const role = storedProfile?.profile?.profile || "Utilisateur";
        const fullName = [this.state.last_name, this.state.family_name, this.state.first_name].filter(Boolean).join(" ");

        return (
            <main className="ev-page account-profile-page">
                <section className="account-profile-hero">
                    <div className="account-profile-hero__glow" aria-hidden="true" />
                    <div className="account-profile-hero__identity">
                        <div className="account-profile-hero__avatar">
                            {this.state.avatar ? <img src={this.state.avatar} alt={fullName || "Photo de profil"} /> : <span>{this.getInitials()}</span>}
                            <i aria-hidden="true"><FeatherIcon icon="check" size={13} /></i>
                        </div>
                        <div className="account-profile-hero__copy">
                            <span className="account-profile-hero__eyebrow"><FeatherIcon icon="user" size={13} /> Mon espace personnel</span>
                            <h1>{fullName || "Mon profil"}</h1>
                            <p>Gérez vos informations personnelles et la sécurité de votre compte.</p>
                            <div className="account-profile-hero__tags">
                                <span><FeatherIcon icon="shield" size={13} /> {role}</span>
                                <span className="is-active"><i /> Compte actif</span>
                            </div>
                        </div>
                    </div>
                    <div className="account-profile-hero__contacts">
                        <a href={this.state.email ? `mailto:${this.state.email}` : undefined}>
                            <i><FeatherIcon icon="mail" size={17} /></i><span><small>Adresse e-mail</small><strong>{this.state.email || "Non renseignée"}</strong></span>
                        </a>
                        <a href={this.state.tel ? `tel:${this.state.tel}` : undefined}>
                            <i><FeatherIcon icon="phone" size={17} /></i><span><small>Téléphone</small><strong>{this.state.tel || "Non renseigné"}</strong></span>
                        </a>
                        <div>
                            <i><FeatherIcon icon="map-pin" size={17} /></i><span><small>Adresse</small><strong>{this.state.adress || "Non renseignée"}</strong></span>
                        </div>
                    </div>
                </section>

                <div className="account-profile-layout">
                    <aside className="account-profile-sidebar">
                        <ProfilImage userId={this.state.id} />
                        <div className="account-profile-tip">
                            <span><FeatherIcon icon="shield" size={18} /></span>
                            <div><strong>Vos données sont protégées</strong><p>Gardez vos coordonnées à jour pour sécuriser votre accès.</p></div>
                        </div>
                    </aside>

                    <div className="account-profile-content">
                        <section className="account-profile-card">
                            <header className="account-profile-card__header">
                                <div className="account-profile-card__icon"><FeatherIcon icon="user" size={19} /></div>
                                <div><span>Informations personnelles</span><h2>Vos coordonnées</h2><p>Ces informations permettent de vous identifier dans l’application.</p></div>
                                <span className="account-profile-card__step">01</span>
                            </header>
                            <div className="account-profile-form">
                                <div className="account-profile-form__grid">
                                    {this.renderField("last_name", "Nom", "user", "text", "Votre nom")}
                                    {this.renderField("family_name", "Post-nom", "users", "text", "Votre post-nom")}
                                    {this.renderField("first_name", "Prénom", "smile", "text", "Votre prénom")}
                                    {this.renderField("tel", "Téléphone", "phone", "tel", "Votre numéro")}
                                    {this.renderField("email", "Adresse e-mail", "mail", "email", "nom@exemple.com")}
                                    {this.renderField("adress", "Adresse", "map-pin", "text", "Votre adresse")}
                                </div>
                                <footer className="account-profile-form__footer">
                                    <div className={`account-profile-feedback ${this.state.profileError ? "is-error" : this.state.profileSaved ? "is-success" : ""}`}>
                                        {(this.state.profileError || this.state.profileSaved) && <FeatherIcon icon={this.state.profileError ? "alert-circle" : "check-circle"} size={15} />}
                                        <span>{this.state.profileError || (this.state.profileSaved ? "Vos modifications ont été enregistrées." : "Tous les champs restent modifiables.")}</span>
                                    </div>
                                    <button type="button" className="account-profile-primary" disabled={this.state.btn} onClick={this.storeProfile}>
                                        <FeatherIcon icon={this.state.btn ? "loader" : "save"} size={16} className={this.state.btn ? "user-search-spin" : ""} />
                                        {this.state.btn ? "Enregistrement…" : "Enregistrer les modifications"}
                                    </button>
                                </footer>
                            </div>
                        </section>

                        <section className="account-profile-card account-profile-security">
                            <header className="account-profile-card__header">
                                <div className="account-profile-card__icon is-security"><FeatherIcon icon="lock" size={19} /></div>
                                <div><span>Sécurité du compte</span><h2>Modifier le mot de passe</h2><p>Choisissez un mot de passe unique que vous n’utilisez nulle part ailleurs.</p></div>
                                <span className="account-profile-card__step">02</span>
                            </header>
                            <div className="account-profile-form">
                                <div className="account-profile-form__grid is-password">
                                    {this.renderField("password", "Nouveau mot de passe", "key", "password", "••••••••")}
                                    {this.renderField("confirmed", "Confirmer le mot de passe", "check-circle", "password", "••••••••")}
                                </div>
                                <footer className="account-profile-form__footer">
                                    <div className={`account-profile-feedback ${this.state.passwordError ? "is-error" : ""}`}>
                                        {this.state.passwordError && <FeatherIcon icon="alert-circle" size={15} />}
                                        <span>{this.state.passwordError || "Utilisez au moins 8 caractères pour plus de sécurité."}</span>
                                    </div>
                                    <button type="button" className="account-profile-secondary" disabled={this.state.passwordBtn} onClick={this.storePassword}>
                                        <FeatherIcon icon={this.state.passwordBtn ? "loader" : "lock"} size={16} className={this.state.passwordBtn ? "user-search-spin" : ""} />
                                        {this.state.passwordBtn ? "Modification…" : "Mettre à jour le mot de passe"}
                                    </button>
                                </footer>
                            </div>
                        </section>
                    </div>
                </div>
            </main>
        );
    }
}

export default Profil;
